import axios from 'axios'
import qs from 'qs'

export default{
  namespaced: true,
  state: {
    company: null,
    positionTypes: null,
    vendorTypes: null,
    activePositionTypes: null,
    activeVendorTypes: null,
    properties: null,
    vendors: null,
    positionForEdit: null,
    vendorTypeForEdit: null
  },
  mutations: {
    updateCompany (state, companyData) {
      console.log('setting company state: ' + JSON.stringify(companyData, null, 2))
      state.company = companyData
    },
    updatePositionTypes (state, typeData) {
      console.log('setting company positionTypes: ' + JSON.stringify(typeData, null, 2))
      state.positionTypes = typeData
      state.activePositionTypes = state.positionTypes.filter((v, i, arr) => v.active === true)
    },
    updateVendorTypes (state, typeData) {
      console.log('setting company vendor Types: ' + JSON.stringify(typeData, null, 2))
      state.vendorTypes = typeData
      state.activeVendorTypes = state.vendorTypes.filter((v, i, arr) => v.active === true)
    },
    setPositionForEdit (state, position) {
      console.log('setting edit position: ' + JSON.stringify(position, null, 2))
      state.positionForEdit = position
    },
    setVendorTypeForEdit (state, vendorType) {
      console.log('setting edit vendor Type: ' + JSON.stringify(vendorType, null, 2))
      state.vendorTypeForEdit = vendorType
    },
    updateProperties (state, propertyData) {
      console.log('setting company properties: ' + JSON.stringify(propertyData, null, 2))
      state.properties = propertyData
    },
    updateVendors (state, vendorData) {
      console.log('setting company vendors: ' + JSON.stringify(vendorData, null, 2))
      state.vendors = vendorData
    }
  },
  actions: {
    async saveCompany ({commit, rootState}, company) {
      console.log('Saving Company: ' + JSON.stringify(company, null, 2))
      return axios.post(
        `/api/company/${rootState.userCurrentCompany.companyId}/save`, company
      )
    },
    async getCompanyForEdit ({commit, state, rootState}) {
      return axios.get(
        '/api/company/' + rootState.userCurrentCompany.companyId
      )
        .catch((e) => console.log(
          `Error: the server responded with '${e}: ${
            e
          }'`
        ))
    },
    async loadPositionTypes ({commit, state, rootState}) {
      console.log('/api/company/' + rootState.userCurrentCompany.companyId + '/positiontypes')
      try {
        return await axios.get(
          '/api/company/' + rootState.userCurrentCompany.companyId + '/positiontypes'
        )
          .then(result => commit('updatePositionTypes', result.data.types))
      } catch (e) {
        console.log(
          `Error: the server responded with '${e.response.status}: ${
            e.response.statusText
          }'`
        )
      }
    },
    async getPositionTypes ({commit, state, rootState}, request) {
      console.log('/api/company/' + rootState.userCurrentCompany.companyId + '/positiontypes')
      try {
        var requestString = '/api/company/' + rootState.userCurrentCompany.companyId + '/positiontypes'
        if (request != null) {
          var params = { sortBy: request.sortBy, sortDirection: request.sortDirection, search: request.search }
          return axios.get(requestString, {params: params})
        } else {
          return axios.get(requestString)
        }
      } catch (e) {
        console.log(
          `Error: the server responded with '${e.response.status}: ${
            e.response.statusText
          }'`
        )
      }
    },
    async savePositionType ({commit, state, rootState, dispatch}, modalPosition) {
      console.log('Saving type: ' + JSON.stringify(modalPosition, null, 2))
      const newPosition = modalPosition
      console.log(
        'handle Save event ' + JSON.stringify(modalPosition, null, 2)
      )
      try {
        await axios.post(
          '/api/company/' + rootState.userCurrentCompany.companyId + '/positiontype',
          newPosition
        ).then(data => {
          console.log('Data is: ' + data)
          dispatch('loadPositionTypes')
        })
      } catch (e) {
        this.apiMessage = `Error: the server responded with '${
          e.response.status
        }: ${e.response.statusText}'`
      }
    },
    async getVendorTypes ({commit, state, rootState}, request) {
      console.log('/api/company/' + rootState.userCurrentCompany.companyId + '/vendortypes')
      try {
        var requestString = '/api/company/' + rootState.userCurrentCompany.companyId + '/vendortypes'
        if (request != null) {
          var params = { sortBy: request.sortBy, sortDirection: request.sortDirection, search: request.search }
          return axios.get(requestString, {params: params})
        } else {
          return axios.get(requestString)
        }
      } catch (e) {
        console.log(
          `Error: the server responded with '${e.response.status}: ${
            e.response.statusText
          }'`
        )
      }
    },
    async saveVendorType ({commit, state, rootState, dispatch}, vendorTypeForSave) {
      console.log('Saving type: ' + JSON.stringify(vendorTypeForSave, null, 2))
      const newVendorType = vendorTypeForSave
      console.log(
        'handle Save event ' + JSON.stringify(newVendorType, null, 2)
      )
      try {
        await axios.post(
          '/api/company/' + rootState.userCurrentCompany.companyId + '/vendorType',
          newVendorType
        ).then(data => {
          console.log('Data is: ' + data)
        })
      } catch (e) {
        this.apiMessage = `Error: the server responded with '${
          e.response.status
        }: ${e.response.statusText}'`
      }
    },
    async getPeopleForManagement ({commit, state, rootState}, request) {
      try {
        var requestString = `/api/company/${rootState.userCurrentCompany.companyId}/people`
        if (request != null) {
          var showArchived = request.showArchived != null ? request.showArchived : false
          var params = { sortBy: request.sortBy, sortDirection: request.sortDirection, showArchived: showArchived, search: request.search }
          return axios.get(requestString, {params: params})
        } else {
          return axios.get(requestString)
        }
      } catch (e) {
        console.log(
          `Error: the server responded with '${e.response.status}: ${
            e.response.statusText
          }'`
        )
      }
    },
    async getPersonForEdit ({commit, state, rootState}, personId) {
      try {
        return await axios.get(
          `/api/company/${rootState.userCurrentCompany.companyId}/people/${personId}`
        )
      } catch (e) {
        console.log(
          `Error: the server responded with '${e.response.status}: ${
            e.response.statusText
          }'`
        )
      }
    },
    async savePerson ({commit, state, rootState, dispatch}, person) {
      try {
        const savePerson = person
        console.log('Saving person: ' + JSON.stringify(savePerson, null, 2))
        var returnValue = await axios.post(
          '/api/company/' + rootState.userCurrentCompany.companyId + '/person', savePerson
        ).then((response) => {
          console.log('Response: ' + response.data)
          return response.data
        })
        return returnValue
      } catch (e) {
        this.apiMessage = `Error: the server responded with '${
          e.response.status
        }: ${e.response.statusText}'`
      }
    },
    async loadProperties ({commit, state, rootState}) {
      try {
        await axios.get(
          '/api/company/' + rootState.userCurrentCompany.companyId + '/user/properties'
        )
          .then(result => commit('updateProperties', result.data.properties))
      } catch (e) {
        console.log(
          `Error: the server responded with '${e.response.status}: ${
            e.response.statusText
          }'`
        )
      }
    },
    getProperties ({commit, state, rootState}, request) {
      try {
        var requestString = '/api/company/' + rootState.userCurrentCompany.companyId + `/user/properties`
        if (request != null) {
          var showArchived = request.showArchived != null ? request.showArchived : false
          var params = { sortBy: request.sortBy, sortDirection: request.sortDirection, showArchived: showArchived, search: request.search }
          return axios.get(requestString, {params: params})
        } else {
          return axios.get(requestString)
        }
      } catch (e) {
        console.log(
          `Error: the server responded with '${e.response.status}: ${
            e.response.statusText
          }'`
        )
      }
    },
    getProperty ({commit, state, rootState}, propertyId) {
      try {
        return axios.get(
          `/api/company/${rootState.userCurrentCompany.companyId}/properties/${propertyId}`
        )
      } catch (e) {
        console.log(
          `Error: the server responded with '${e.response.status}: ${
            e.response.statusText
          }'`
        )
      }
    },
    async getPropertyContacts ({commit, state, rootState}, propertyId) {
      try {
        return await axios.get(
          `/api/company/${rootState.userCurrentCompany.companyId}/property/${propertyId}/poc`
        )
      } catch (e) {
        console.log(
          `Error: the server responded with '${e.response.status}: ${
            e.response.statusText
          }'`
        )
      }
    },
    async getPropertyGroups ({commit, state, rootState}, request) {
      try {
        var requestString = `/api/company/${rootState.userCurrentCompany.companyId}/propertygroups`
        if (request != null) {
          var params = { sortBy: request.sortBy, sortDirection: request.sortDirection, search: request.search }
          return axios.get(requestString, {params: params})
        } else {
          return axios.get(requestString)
        }
      } catch (e) {
        console.log(
          `Error: the server responded with '${e.response.status}: ${
            e.response.statusText
          }'`
        )
      }
    },
    async getPropertyGroup ({commit, state, rootState}, id) {
      try {
        return await axios.get(
          `/api/company/${rootState.userCurrentCompany.companyId}/propertygroups/${id}`
        )
      } catch (e) {
        console.log(
          `Error: the server responded with '${e.response.status}: ${
            e.response.statusText
          }'`
        )
      }
    },
    async createPropertyGroup ({commit, state, rootState, dispatch}, propertyGroup) {
      try {
        console.log('Saving propertyGroup: ' + JSON.stringify(propertyGroup, null, 2))
        await axios.post(
          `/api/company/${rootState.userCurrentCompany.companyId}/propertygroups`,
          propertyGroup
        )
      } catch (e) {
        this.apiMessage = `Error: the server responded with '${
          e.response.status
        }: ${e.response.statusText}'`
      }
    },
    async savePropertyGroup ({commit, state, rootState, dispatch}, propertyGroup) {
      try {
        console.log('Saving propertyGroup: ' + JSON.stringify(propertyGroup, null, 2))
        await axios.post(
          `/api/company/${rootState.userCurrentCompany.companyId}/propertygroups/${propertyGroup.id}`,
          propertyGroup
        )
      } catch (e) {
        this.apiMessage = `Error: the server responded with '${
          e.response.status
        }: ${e.response.statusText}'`
      }
    },
    async saveProperty ({commit, state, rootState, dispatch}, property) {
      try {
        console.log('Saving property: ' + JSON.stringify(property, null, 2))
        await axios.post(
          '/api/company/' + rootState.userCurrentCompany.companyId + '/property',
          property
        )
      } catch (e) {
        this.apiMessage = `Error: the server responded with '${
          e.response.status
        }: ${e.response.statusText}'`
      }
    },
    async saveCategory ({commit, state, rootState, dispatch}, category) {
      try {
        console.log('Saving category: ' + JSON.stringify(category, null, 2))
        category.categoryName = category.name
        category.categoryId = category.id
        await axios.post(
          `/api/company/${rootState.userCurrentCompany.companyId}/eventTypes/${category.typeId}/categories/${category.id}`,
          category
        )
      } catch (e) {
        this.apiMessage = `Error: the server responded with '${
          e.response.status
        }: ${e.response.statusText}'`
      }
    },
    async createCategory ({commit, state, rootState, dispatch}, category) {
      try {
        console.log('Saving category: ' + JSON.stringify(category, null, 2))
        category.categoryName = category.name
        await axios.post(
          `/api/company/${rootState.userCurrentCompany.companyId}/eventTypes/${category.typeId}/categories`,
          category
        )
      } catch (e) {
        this.apiMessage = `Error: the server responded with '${
          e.response.status
        }: ${e.response.statusText}'`
      }
    },
    async createPropertyOnCallNumber ({commit, state, rootState, dispatch}, propertyId) {
      try {
        console.log('Creating Oncall Phone Number ' + propertyId)
        return await axios.post(
          `/api/company/${rootState.userCurrentCompany.companyId}/property/${propertyId}/oncall/create`
        )
      } catch (e) {
        this.apiMessage = `Error: the server responded with '${
          e.response.status
        }: ${e.response.statusText}'`
      }
    },
    async getVendors ({commit, state, rootState}, request) {
      try {
        var requestString = '/api/company/' + rootState.userCurrentCompany.companyId + '/vendors'
        if (request != null) {
          var params = { sortBy: request.sortBy, sortDirection: request.sortDirection, search: request.search }
          return axios.get(requestString, {params: params})
        } else {
          return axios.get(requestString)
        }
      } catch (e) {
        console.log(
          `Error: the server responded with '${e.response.status}: ${
            e.response.statusText
          }'`
        )
      }
    },
    async loadVendorForEdit ({commit, state, rootState}, vendorId) {
      try {
        await axios.get(
          `/api/company/${rootState.userCurrentCompany.companyId}/vendors/${vendorId}`
        )
          .then(result => commit('setVendorForEdit', result.data.vendor))
      } catch (e) {
        console.log(
          `Error: the server responded with '${e.response.status}: ${
            e.response.statusText
          }'`
        )
      }
    },
    async getVendorForEdit ({commit, state, rootState}, vendorId) {
      try {
        return await axios.get(
          `/api/company/${rootState.userCurrentCompany.companyId}/vendors/${vendorId}`
        )
      } catch (e) {
        console.log(
          `Error: the server responded with '${e.response.status}: ${
            e.response.statusText
          }'`
        )
      }
    },
    async saveVendor ({commit, state, rootState, dispatch}, vendor) {
      try {
        const saveVendor = vendor
        console.log('Saving vendor: ' + JSON.stringify(saveVendor, null, 2))
        await axios.post(
          '/api/company/' + rootState.userCurrentCompany.companyId + '/vendor',
          saveVendor
        ).then(data => {
          console.log('Data is: ' + data)
        })
      } catch (e) {
        this.apiMessage = `Error: the server responded with '${
          e.response.status
        }: ${e.response.statusText}'`
      }
    },
    async saveInsurancePolicy ({rootState}, policy) {
      console.log('Saving insurance: ' + JSON.stringify(policy, null, 2))
      try {
        var apiPath = `/api/company/${rootState.userCurrentCompany.companyId}/insurancepolicies`
        // Include both new structured fields (deductibleTerms, coverageLines) and legacy fields
        // (standardDeductible, specialDeductibles, lineOfCoverage, coverageTypes) for backward
        // compatibility. The API handles migration on save when it receives the new fields.
        let request = {
          policy: {
            ...policy,
            // Explicit new fields (also present on the policy object via spread above)
            deductibleTerms: policy.deductibleTerms || [],
            coverageLines: policy.coverageLines || []
          }
        }
        return axios.post(apiPath, request)
        .then((result) => {
          console.log(result.data)
          return result.data
        })
        .catch(error => {
          if(error.response && error.response.status == 400) {
            console.log(error.response.data)
            return error.response.data
          }
        })
      } catch (error) {
        console.log(`Error: the server responded with '${e}: ${e}'`)
      }
    },
    async getInsurancePoliciesByCompany ({commit, state, rootState}) {
      try {
        var requestString = `/api/company/${rootState.userCurrentCompany.companyId}/insurancepolicies`
        return axios.get(requestString)
      } catch (e) {
        console.log(
          `Error: the server responded with '${e.response.status}: ${
            e.response.statusText
          }'`
        )
      }
    },
    async getInsurancePolicies ({commit, state, rootState}, request) {
      try {
        let queryString = `${qs.stringify(request, {allowDots: true})}`
        var requestString = `/api/company/${rootState.userCurrentCompany.companyId}/insurancepolicies?${queryString}`
        if (request != null) {
          return axios.get(requestString)
        } else {
          return axios.get(requestString)
        }

      } catch (e) {
        console.log(
          `Error: the server responded with '${e.response.status}: ${
            e.response.statusText
          }'`
        )
      }
    },
    async getInsurancePolicy ({commit, state, rootState}, policyId) {
      try {
        var requestString = `/api/company/${rootState.userCurrentCompany.companyId}/insurancepolicies/${policyId}`
        return axios.get(requestString)
      } catch (e) {
        console.log(
          `Error: the server responded with '${e.response.status}: ${
            e.response.statusText
          }'`
        )
      }
    },
    async getInsurancePolicyForEdit ({commit, state, rootState}, policyId) {
      try {
        let policyIdParam = policyId == null ? '' : `/${policyId}`
        var requestString = `/api/company/${rootState.userCurrentCompany.companyId}/insurancepolicies/foredit${policyIdParam}`
        return axios.get(requestString)
      } catch (e) {
        console.log(
          `Error: the server responded with '${e.response.status}: ${
            e.response.statusText
          }'`
        )
      }
    },
    async deleteInsurancePolicy ({commit, state, rootState}, policyId) {
      try {
        var requestString = `/api/company/${rootState.userCurrentCompany.companyId}/insurancepolicies/${policyId}`
        return axios.delete(requestString)
      } catch (e) {
        console.log(
          `Error: the server responded with '${e.response.status}: ${
            e.response.statusText
          }'`
        )
      }
    },
    async getPropertyInsurancePolicyStatsForList ({commit, state, rootState}) {
      try {
        var requestString = `/api/company/${rootState.userCurrentCompany.companyId}/propertyinsurancepolicystatsforlist`
        return axios.get(requestString)
      } catch (e) {
        console.log(
          `Error: the server responded with '${e.response.status}: ${
            e.response.statusText
          }'`
        )
      }
    },
    async getPropertyInsurancePolicyDetails ({commit, state, rootState}, propertyId) {
      try {
        var requestString = `/api/company/${rootState.userCurrentCompany.companyId}/propertyinsurancepolicydetails/${propertyId}`
        return axios.get(requestString)
      } catch (e) {
        console.log(
          `Error: the server responded with '${e.response.status}: ${
            e.response.statusText
          }'`
        )
      }
    },
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/company.js